
const text = (value, intl) => {
  if (typeof (value) === 'string') {
    return intl.formatMessage({ id: value });
  }
  return value;
};

const error = (value, intl, defaultValue, params) => {
  if (typeof (value) === 'string') {
    let returnValue = intl.formatMessage({ id: value });
    let replacekey;
    if (returnValue === value && params) {
      for (const key in params) {
        replacekey = `{${key}}`;
        defaultValue = defaultValue.replace(replacekey, params[key]);
      }

      return defaultValue || text("DEFAULT_ERROR", intl);
    }

    if (returnValue.includes('%s')) {
      const splitted = returnValue.split(/(%s)/);
      const count = (returnValue.match(/%s/g) || []).length;

      if (count > 0) {
        let returnValueTmp = '';
        let startedStr = '';
        for (let i = 0; i < splitted.length; i++) {
          if (splitted[i] === '%s') {
            for (const key in params) {
              if (startedStr !== key) {
                returnValueTmp += params[key];
                startedStr = key;
                break;
              }
              startedStr = key;
            }
          } else {
            returnValueTmp += splitted[i];
          }
        }
        return returnValueTmp;
      }

      return defaultValue || text("DEFAULT_ERROR", intl);
    }
    for (const key in params) {
      replacekey = `{${key}}`;
      returnValue = returnValue.replace(replacekey, params[key]);
    }
    return returnValue || text('DEFAULT_ERROR', intl);
  }
  return value;
};

const textArray = (array, intl) => {
  if (Array.isArray(array)) {
    const tempArray = array.map(value => text(value, intl));
    return tempArray;
  }
  return array;
};


const objectClassification = {
  text,
  error,
  textArray,
};

const languageTranslator = ({
  type, key, intl, defaultValue, params,
}) => {
  const functions = objectClassification[type || 'text'];

  if (intl === null || intl === undefined) {
    throw new Error('intl is not define');
  }
  if (typeof functions === 'function') {
    return functions(key, intl, defaultValue, params);
  }
  throw new Error(`no such objectClassification "${type}"`);
};

export default languageTranslator;